import React from 'react';
import { Handle, Position } from 'reactflow';

class NodeInitial extends React.Component {
  render() {
    return (
      <>
        <div className="dndnode input">
          Change Options in Selctions
        </div>
        <Handle type="target" position={Position.Top} />
        <Handle type="source" position={Position.Bottom} />
      </>
    );
  }
}

export default NodeInitial;
